import { Fragment, type ReactNode } from 'react';

import classNames from 'classnames';

import { type SerializableNode, SerializeTextLeaf } from '@/index';

const getElement = ({
  node,
  children,
  key,
}: {
  node: SerializableNode;
  children: ReactNode;
  key: string;
}): ReactNode => {
  if ('text' in node) {
    return <SerializeTextLeaf key={key} leaf={node} />;
  }

  switch (node.type) {
    case 'listItem': {
      return (
        <li key={key} className={classNames(`dream-products-${node.type}`, '[&>p]:inline [&>p]:m-0')}>
          {children}
        </li>
      );
    }
    case 'bulletList':
      return (
        <ul key={key} className={classNames(`dream-products-${node.type}`, 'list-inside list-disc')}>
          {children}
        </ul>
      );
    case 'orderedList':
      return (
        <ol key={key} className={classNames(`dream-products-${node.type}`, 'list-inside	list-decimal')}>
          {children}
        </ol>
      );
    case 'paragraph':
      return (
        <p key={key} className={classNames(`dream-products-${node.type}`)}>
          {children}
        </p>
      );
    case 'heading': {
      const level = node.attrs?.level as number;

      switch (level) {
        case 1:
          return (
            <h1 key={key} className={classNames(`dream-products-${node.type}`)}>
              {children}
            </h1>
          );
        case 2:
          return (
            <h2 key={key} className={classNames(`dream-products-${node.type}`)}>
              {children}
            </h2>
          );
        case 3:
          return (
            <h3 key={key} className={classNames(`dream-products-${node.type}`)}>
              {children}
            </h3>
          );
        case 4:
          return (
            <h4 key={key} className={classNames(`dream-products-${node.type}`)}>
              {children}
            </h4>
          );
        case 5:
          return (
            <h5 key={key} className={classNames(`dream-products-${node.type}`)}>
              {children}
            </h5>
          );
        default:
          return (
            <h6 key={key} className={classNames(`dream-products-${node.type}`)}>
              {children}
            </h6>
          );
      }
    }
    case 'doc': {
      return <div className={`dream-products-${node.type}`}>{children}</div>;
    }
    case 'hardBreak':
      return <br />;
    default:
      return <Fragment key={key}>{children}</Fragment>;
  }
};

export { getElement };
